export const SENTRY_RESOLVE_PROMPT = `## Error Details

**Title:** {{trigger.issueTitle}}
**Sentry URL:** {{trigger.issueUrl}}
**Project:** {{trigger.sentryProjectSlug}}

{{#if trigger.stacktrace}}
## Stacktrace

{{trigger.stacktrace}}
{{/if}}

{{#if trigger.errorMessage}}
**Error Message:** {{trigger.errorMessage}}
{{/if}}

## Triage Summary

{{state.triageSummary}}

## Investigation Summary

{{nodes.investigate.output.summary}}

## Investigation Reasoning

{{nodes.investigate.output.reasoning}}

{{#if nodes.investigate.output.fixPlan}}
## Proposed Fix Plan

{{nodes.investigate.output.fixPlan}}
{{/if}}

{{#if nodes.triage.approvalResponse.feedback}}
## Additional Context from Engineer

{{nodes.triage.approvalResponse.feedback}}
{{/if}}

## Your Task

1. **Fix**: Implement a minimal, focused fix that addresses the root cause — not just the symptom. Add regression tests that would have caught this error.
2. **PR**: Create a pull request with:
   - Title: "fix: [Sentry] {{trigger.issueTitle}}"
   - Link to the Sentry issue: {{trigger.issueUrl}}
   - Description of root cause and fix

## Guidelines

- Keep the fix minimal and focused — don't refactor unrelated code
- Ensure all existing tests still pass
- If the fix requires a migration, document it clearly
- Tests, formatting, and any other changes required for PR to be merged must be completed before submitting.

## Output

You MUST respond with JSON matching this schema:
- "status": "pr_submitted" if you successfully created a PR, or "something_went_wrong" if you could not
- "pr": the URL of the pull request (required if status is "pr_submitted")
- "message": a brief description of the fix and PR, or an explanation of what went wrong

{{#if memory.relevant}}
## Context from Previous Fixes
{{memory.relevant}}
{{/if}}`;
